(() => {
  const form = document.querySelector('[data-story-offer-form]');
  if (!form) return;

  const button = form.querySelector('button[data-offer-cta]');
  const choices = [...form.querySelectorAll('[data-offer-choice]')];
  const radios = [...form.querySelectorAll('[data-offer-radio]')];

  function selectChoice(radio) {
    choices.forEach(choice => choice.classList.toggle('is-selected', choice.contains(radio)));
    button.textContent = radio.dataset.offerCta;
  }

  radios.forEach(radio => radio.addEventListener('change', () => selectChoice(radio)));
  button.addEventListener('click', () => {
    const selected = radios.find(radio => radio.checked) || radios[0];
    document.dispatchEvent(new CustomEvent('contelune:open-personalization', { detail: { offer: selected.value, trigger: button } }));
  });
  selectChoice(radios.find(radio => radio.checked) || radios[0]);
})();
